import React, { useEffect, useState, Fragment } from "react";
import Cookies from "js-cookie";
import SecondLayout from "../layouts/SecondLayout";
import ImageWithLeftCard from "../components/partials/home/ImageWithLeftCard";
import ImageWithRightCard from "../components/partials/home/ImageWithRightCard";
import { Variables } from "../variables";

const MyBlogs = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");
  const [content, setContent] = useState([]);

  // loader + error
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // watch language cookie
  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  // fetch content (show ONLY loader without layout while loading)
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const url =
          Variables.API_URL +
          "Rasha/Client/Page/4?isEnglish=" +
          (language === "en");

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result?.message || "Failed to fetch content");
        }

        if (isMounted) setContent(Array.isArray(result) ? result : []);
      } catch (err) {
        if (isMounted && err.name !== "AbortError") {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [language]);

  // --- Loader (no layout) ---
  if (loading) {
    return (
      <div style={styles.loaderWrap}>
        <div style={styles.spinner} />
      </div>
    );
  }

  // --- Error (no layout) ---
  if (error) {
    return <div style={styles.errorBox}>{error}</div>;
  }

  // --- Main UI (with layout AFTER loading) ---
  return (
    <SecondLayout>
      <div className="container">
        <h2 className="about-me-title">{content?.[0]?.WidgetName}</h2>
      </div>

      {content.map((c, index) => {
        const key = c.WidgetId ?? `${c.WidgetTypeId}-${c.WidgetValue?.Id ?? index}`;
        const t = {
          en: {
            title: "",
            heading: c?.WidgetValue?.Title,
            paragraph: c?.WidgetValue?.Body,
            button: c?.WidgetValue?.ButtonText,
          },
          ar: {
            title: "",
            heading: c?.WidgetValue?.TitleAr,
            paragraph: c?.WidgetValue?.BodyAr,
            button: c?.WidgetValue?.ButtonTextAr,
          },
        };
        const img = Variables.API_PUBLISHED + (c?.WidgetValue?.ImageUrl || "");
        const link = c?.WidgetValue?.ButtonUrl;

        if (index % 2 === 0) {
          return (
            <Fragment key={key}>
              <ImageWithLeftCard link={link} t={t} image={img} />
              <div className="mb-40"></div>
            </Fragment>
          );
        } else {
          return (
            <Fragment key={key}>
              <ImageWithRightCard link={link} t={t} image={img} />
              {index + 1 < content.length ? <div className="mb-40"></div> : null}
            </Fragment>
          );
        }
      })}
    </SecondLayout>
  );
};

const styles = {
  loaderWrap: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 48,
    height: 48,
    border: "4px solid rgba(0,0,0,0.1)",
    borderTopColor: "#000",
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  },
  errorBox: {
    margin: 16,
    padding: "12px 16px",
    border: "1px solid #f3c2c2",
    background: "#fff5f5",
    color: "#b00020",
    borderRadius: 8,
  },
};

// inject keyframes (once, unique id for this page)
if (typeof document !== "undefined" && !document.getElementById("blogs-spin-kf")) {
  const styleEl = document.createElement("style");
  styleEl.id = "blogs-spin-kf";
  styleEl.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(styleEl);
}

export default MyBlogs;
